module.exports = __webpack_public_path__ + "static/Salinenpark-f71e57e69fc742bc6bd846c80bbf118e.JPG";